export const createBaseline = ({
    fontFamily,
    bodyFontSize,
}: {
    fontFamily: string;
    bodyFontSize: string;
}) => ({
    styleOverrides: `
    *, *::before, *::after {
        letter-spacing: 0;
    }

    html {
        font-size: 62.5%;
    }

    body {
        font-family: ${fontFamily};
        font-size: ${bodyFontSize};
        letter-spacing: 0;
    }
`,
});
